import { useModals } from '@any-ui-react/modals';
import type { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';
import { DeleteRecordModalContent } from './DeleteRecordModalContent';

interface Props {
  title?: string;
  successButtonText?: ReactNode;
  onSuccess: () => void | Promise<void>;
}

export const useDeleteRecordModal = () => {
  const modalId = uuid();
  const { openModal, closeModal } = useModals();

  const openDeleteRecordModal = ({ title, successButtonText, onSuccess }: Props) => {
    openModal({
      modalId,
      centered: true,
      title: title ?? 'Are you sure to delete it?',
      size: 'lg',
      children: (
        <DeleteRecordModalContent
          successButtonText={successButtonText}
          onClose={() => closeModal(modalId)}
          onSuccess={onSuccess}
        />
      ),
    });
  };

  return { openDeleteRecordModal };
};
